<template>
  <div v-loading.fullscreen="isFullScreenLoading" class="w-full">
    <template v-if="firstLinkingBarcodes">
      <el-collapse accordion :class="'mb-5'">
        <template v-for="(lbarcode, tdIndex) in firstLinkingBarcodes" :key="lbarcode.id">
          <LinkingBarcodeInfo
            v-if="getBarcodeTypeInfoByType(lbarcode)"
            :mainBarcodeId="barcode.id"
            :barcode="lbarcode"
            :barcodeTypeInfo="getBarcodeTypeInfoByType(lbarcode)"
            :displayMenu="isAction && isLastestLinkingBarcode(0) && tdIndex === firstLinkingBarcodes.length - 1"
            :trackingNumberMes="messages.trackingNumber"
            :mainKey="linkedBarcodePathKey.activationData"
            :indexLinkedBarcode="tdIndex"
            :linkedBarcodeHrefType="currentBarcodeType?.linkedBarcodeHrefType"
            @barcode:unlink="unlinkBarcode"
            @barcode:redirect="redirectTo"
          />
        </template>
      </el-collapse>
    </template>

    <template v-if="hasTrackingData">
      <div
        v-if="isMaskedData"
        style="margin: 0px 50px 25px 50px; color: red; font-family: Noto Sans JP !important"
        :class="`text-center px-4 py-3 bg-white rounded-lg`"
      >
        {{ $t('Masked permission items') }}
      </div>

      <div v-for="(serialTrackingData, idx) in serialTrackingDatas" :key="idx" class="tracking-record mb-5">
        <div class="flex items-center w-full">
          <div
            class="tracking-record-title flex justify between h-9 items-center text-white rounded-full w-full px-3 py-1 bg-gray-400"
          >
            <span class="flex-grow ml-3">
              {{ serialTrackingData.trackingPointName }}
            </span>
          </div>
        </div>
        <div class="step-body py-2 px-6 ml-5 relative">
          <div v-if="serialTrackingData.staffName" class="flex mb-3">
            <span class="label-box-custom break-all w-20">{{ $t('barcode.tracked_username') }}</span>
            <div class="pl-2 break-all w-full--20 flex items-center" v-html="serialTrackingData.staffName"></div>
          </div>
          <div v-if="serialTrackingData.machineCode" class="flex mb-3">
            <span class="label-box-custom break-all w-20">{{ $t('machine_qr') }}</span>
            <div class="pl-2 break-all w-full--20 flex items-center" v-html="serialTrackingData.machineCode"></div>
          </div>
          <div v-if="serialTrackingData.serials && serialTrackingData.serials.length" class="flex mb-3">
            <span class="label-box-custom break-all w-20">{{ $t('serial_code') }}</span>
            <div class="pl-2 w-full--20 flex items-center">
              <div
                style="padding: 8px 16px;
                text-align: center;
                border: 1px solid #c4c4c4;
                border-radius: 4px;
                box-sizing: border-box;
                line-height: 1.5;
                display: inline-block;
                padding: 2px 12px;
                font-weight: 600;
                font-size: 18px;"
                @click="showListStringModal(serialTrackingData.serials, serialTrackingData.trackingPointName)"
              >
                {{ serialTrackingData.serials.length }}
                {{ serialTrackingData.serials.length === 1 ? $t('item') : $t('items') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <div v-if="!firstLinkingBarcodes && !hasTrackingData" class="display-in-center">
      {{ messages.noTrackingHistory }}
    </div>

    <div class="text-center">
      <el-button v-if="isDisplayBackArrow" type="text" @click="$router.go(-1)">
        <IconArrowBack />
      </el-button>
    </div>
  </div>

  <!-- List String Modal -->
  <div class="serial-dialog-area">
    <el-dialog v-model="listStringModalVisible" :title="currentFieldLabel" :show-close="false">
      <div>
        <div style="margin-bottom: 16px; font-weight: bold; text-align: left;">
          {{ $t('total') }}: {{ listStringData.length }} {{ listStringData.length === 1 ? $t('item') : $t('items') }}
        </div>
        <div class="table-scroll-container-tracing">
          <table class="rounded-table sticky-header-table-tracing">
            <thead>
              <tr class="text-center ">
                <th v-for="(col, colIndex) in tableColumns" :key="colIndex" :colspan="col.colspan || 1">
                  {{ col.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in listStringData" :key="index" width="20">
                <template v-for="(col, colIndex) in tableColumns" :key="colIndex">
                  <td v-for="(cell, cellIndex) in col.cells" :key="cellIndex" :class="cell.className || ''">
                    <span v-if="cell.formatter" @click="cell.onClick && cell.onClick(item)">{{
                      cell.formatter(item)
                    }}</span>
                    <span v-else-if="cell.value">{{ cell.value }}</span>
                    <span v-else>{{ item[cell.prop] }}</span>
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #footer>
        <el-button @click="listStringModalVisible = false" type="primary" class="flex justify-self-center ">
          {{ $t('ok') }}
        </el-button>
      </template>
    </el-dialog>
  </div>

  <div class="tracing-dialog">
    <ImageViewerDialog v-model:imageDialogVisible="imageDialogVisible" :image="images" />

    <el-dialog
      width="90%"
      top="0"
      :model-value="undoConfirmBox"
      :close-on-click-modal="false"
      :show-close="true"
      :title="messages.undoTrackingData"
      @closed="undoConfirmBox = false"
    >
      <div class="dialogMessage">{{ messages.confirmUndoTrackingData }}</div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="undoConfirmBox = false">
            {{ messages.cancel }}
          </el-button>
          <el-button type="primary" @click="undoTracking()">
            {{ messages.ok }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog
      center
      width="90%"
      top="0"
      :model-value="signDialog"
      :title="eSignCarouselHeaderLabel"
      @closed="signDialog = false"
    >
      <div>
        <el-carousel @change="onESignCarouselChange" arrow="always" :autoplay="false" indicator-position="none">
          <el-carousel-item v-for="(eSign, key) in arrSignImage" :key="key">
            <div style="border: 1px solid #c4c4c4">
              <img :src="eSign.eSign" alt="eSign" />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button id="AppDialog_closeDialog" type="primary" @click="signDialog = false">
            {{ messages.ok }}
          </el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      center
      width="90%"
      top="0"
      :model-value="fileDialog"
      :title="$t('file_urls')"
      @closed="fileDialog = false"
    >
      <div @click="onPreview(value.url)" class="grid grid-cols-12 mb-2.5" v-for="(value, idx) in arrFile" :key="idx">
        <IconListFile class="col-span-2" />
        <span class="w-full col-span-10 self-center">{{ value?.name }}</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button id="AppDialog_closeDialog" type="primary" @click="fileDialog = false">
            {{ messages.ok }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>

  <div class="dialog-area">
    <el-dialog
      center
      v-model="barcodeDialogVisible"
      width="90%"
      top="0"
      :before-close="beforeCloseDialog"
      :show-close="true"
      :destroy-on-close="false"
      :title="$t('Data_Identity_Confirmation')"
    >
      <div class="concile-dialog-content-data" v-if="trackingDataItemsLoading[selectedIndex]">
        <div class="flex flex-col justify-center flex-shrink-0">
          <div class="barcode-id-small">{{ barcode.id }}</div>
        </div>
        <div class="trackpoint-concile-content">
          {{
            `${trackingDataItemsLoading[selectedIndex].nextTrackPointKey}. ${stepName(
              trackingDataItemsLoading[selectedIndex].nextTrackPointKey
            )}`
          }}
        </div>
        <br />
        <div class="ledger-certified">
          {{
            trackingDataItemsLoading[selectedIndex].isLedgerCertified ? $t('LedgerCertified') : $t('NotLedgerCertified')
          }}
        </div>
        <div class="last-confirm-small">
          {{
            `${$t('Last_Confirm')}: ${convertedDate(
              trackingDataItemsLoading[selectedIndex].lastLedgerCertifiedDateTime
            )}`
          }}
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button round @click="invokeConcile" class="reconcile-btn">
            <i v-if="isLoading" class="el-icon-loading is-loading" />
            <span v-else>
              {{ $t('Reconfirm') }}
            </span>
          </el-button>
          <el-button round class="ok-btn" @click="closeReconcileDialog">
            {{ $t('OK') }}
          </el-button>
        </span>
      </template>
    </el-dialog>

    <SensorDialog
      :project="project"
      :barcode="barcode"
      :trackingDataIndex="trackingDataIndex"
      :isShowDialog="showSensorDialog"
      @dialog:close="showSensorDialog = false"
    />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import ImageViewerDialog from '../components/ImageViewerDialog.vue'
import SensorDialog from '../components/SensorDialog.vue'
import IconEdit from '../components/svg/IconEdit.vue'
import IconFile from '../components/svg/IconFile.vue'
import IconImage from '../components/svg/IconImage.vue'
import IconMap from '../components/svg/IconMap.vue'
import IconMaskedLock from '../components/svg/IconMaskedLock.vue'
import IconVerticalThreeDots from '../components/svg/IconVerticalThreeDots.vue'

import { ECustomFieldType } from '@/utils/enums'
import { formatDateTimeListString, parseDateToYYMMDD, isEmpty, isImagesFile } from '@/utils/helpers'
import {
  IBarcode,
  IBarcodeDefinitionType,
  ICustomFieldData,
  IEsignData,
  IFieldSettings,
  IFile,
  IListStringItem,
  IProject,
  IRedirectData,
  IReferenceCustomFieldData,
  ISerialTrackingData,
  ITracingMessage,
  ITrackingData,
  ITrackPointForms,
  IWeightMeasurement,
  IWeightMeasurementHistoryItem,
} from '@/utils/types'
import { format } from 'date-fns'
import { Emit, Prop } from 'vue-property-decorator'
import LinkingBarcodeInfo from '../components/LinkingBarcodeInfo.vue'
import {
  BARCODE_ACTIVATION_DATA_KEYS,
  DATE_TIME,
  FIELD_TYPE,
  LINKED_BARCODE_PATH_KEY,
  MASKED_STR,
  OTHER_COUNTRY_LIST,
  TIMETABLE_DATETIME,
} from '../utils/constants'
import { getGhgEmissionMap } from '../utils/ghgEmission/calc'
import { GhgEmissionCustomFieldConclusion } from '../utils/ghgEmission/GhgEmissionCustomFieldConclusion'
import IconArrowBack from './svg/IconArrowBack.vue'
import IconListFile from './svg/IconListFile.vue'
import IconLock from './svg/IconLock.vue'
import IconSensor from './svg/IconSensor.vue'
import IconUnlock from './svg/IconUnlock.vue'
import { IManufacturingPlan } from '@/utils/types/model/manufacturingPlan'
import { formatDate } from '@/utils/timeUtils'
import router from '@/router'
type TTransformedStructure = Pick<IFieldSettings, 'label' | 'order'> & {
  [key: string]: { label: string }
}

@Options({
  components: {
    IconLock,
    IconUnlock,
    IconMap,
    SensorDialog,
    IconSensor,
    IconImage,
    IconEdit,
    IconVerticalThreeDots,
    LinkingBarcodeInfo,
    IconArrowBack,
    IconMaskedLock,
    IconFile,
    IconListFile,
    ImageViewerDialog,
  },
  emits: ['barcode:undoTracking', 'barcode:unlink', 'web:redirect', 'barcode:invokeConcile', 'barcode:getLedgerStatus'],
  methods: {
    formatDateTimeListString,
    parseDateToYYMMDD,
    isImagesFile,
  },
})
export default class Tracing extends Vue {
  @Prop({ type: Object }) readonly project!: IProject
  @Prop({ type: Object }) readonly barcode!: IBarcode
  @Prop({ type: Object }) readonly messages!: ITracingMessage
  @Prop({ type: Boolean, default: false }) readonly isDisplayBackArrow?: boolean
  @Prop({ type: Boolean, default: true }) readonly isAction?: boolean

  trackingDataIndex = 0
  isLoading = false
  isFullScreenLoading = false
  barcodeDialogVisible = false
  selectedIndex = 0
  imageDialogVisible = false
  images = {}
  signDialog = false
  arrSignImage = [] as IEsignData[]
  arrFile = [] as IFile[]
  undoConfirmBox = false
  editConfirmBox = false
  trackingDataItemsLoading = [] as Array<Record<string, unknown>>
  fileDialog = false
  eSignCarouselIndex = 0
  imageCarouselIndex = 0
  listStringModalVisible = false
  listStringData: IListStringItem[] = []
  currentFieldLabel = ''
  distinctTrackingDataKeys: ITrackingData[] = []
  serialTrackingDatas: ISerialTrackingData[] = []

  get tableColumns() {
    return [
      {
        label: this.$t('barcode.componentItemName'),
        colspan: 2,
        cells: [{ prop: 'itemCode' }, { prop: 'itemName' }],
      },
      {
        label: this.$t('barcode.order'),
        cells: [
          {
            prop: 'orderNumber',
            className: 'underline text-blue-500',
            formatter: () => this.orderNumber,
          },
        ],
      },
      {
        label: this.$t('barcode.lot'),
        cells: [
          {
            prop: 'lot',
          },
        ],
      },
      {
        label: this.$t('barcode.serial_id'),
        cells: [{ prop: 'code', className: 'underline text-blue-500' }],
      },
      { label: this.$t('barcode.machine'), cells: [{ prop: 'machineCode' }] },
      {
        label: this.$t('barcode.time'),
        cells: [
          {
            prop: 'scannedDateTime',
            formatter: (row: IListStringItem) =>
              formatDate(row.scannedDateTime || '', TIMETABLE_DATETIME.TIME_WITH_SECOND_FORMAT),
          },
        ],
      },
      {
        label: this.$t('barcode.quantity'),
        cells: [
          {
            prop: 'amount',
            formatter: (row: IListStringItem) => (!row.amount ? '' : `${row.amount} ${row.unit ?? ''}`),
          },
        ],
      },
    ]
  }

  get orderNumber(): IBarcode {
    return this.$store.state.barcode?.barcode?.manufacturingPlan?.orderNumber
  }

  created() {
    try {
      this.distinctTrackingDataKeys = this.handleDistinctTrackingDataKeys(this.barcode.trackingData)
      this.serialTrackingDatas = this.barcode.serialTrackingDatas ?? []
      this.trackingDataItemsLoading = this.distinctTrackingDataKeys.map((val, idx) => {
        if (this.isDisableLedger(idx)) {
          this.isFullScreenLoading = true
          this.$emit('barcode:getLedgerStatus', idx)
        }
        return { isLoading: false, ...val }
      })
    } catch (error) {
    } finally {
      this.isFullScreenLoading = false
    }
  }

  handleDistinctTrackingDataKeys(trackingData: ITrackingData[]): ITrackingData[] {
    // Filter out items without customFields because the ended not don't have customFields
    const filteredTrackingData = trackingData
      .filter((item) => {
        return item.customFields && Object.keys(item.customFields).length > 0
      })
      .map((item) => {
        let newNextTrackPointKey = item.nextTrackPointKey
        if (item.nextTrackPointKey === '5') {
          newNextTrackPointKey = '1'
        }
        if (item.nextTrackPointKey === '6') {
          newNextTrackPointKey = '2'
        }
        return {
          ...item,
          nextTrackPointKey: newNextTrackPointKey,
        }
      })

    const groupedByNextTrackPointKey = filteredTrackingData.reduce(
      (acc, item, index) => {
        const key = item.nextTrackPointKey
        if (!acc.groups[key]) {
          acc.groups[key] = []
          acc.firstIndex[key] = index
        }
        acc.groups[key].push(item)
        return acc
      },
      { groups: {} as Record<string, ITrackingData[]>, firstIndex: {} as Record<string, number> }
    )
    // Sort keys by their first occurrence index to preserve original order
    const sortedKeys = Object.keys(groupedByNextTrackPointKey.groups).sort(
      (a, b) => groupedByNextTrackPointKey.firstIndex[a] - groupedByNextTrackPointKey.firstIndex[b]
    )

    return sortedKeys.map((key) => {
      const group = groupedByNextTrackPointKey.groups[key]
      // Take the first item as base
      const firstItem = group[0]

      // Combine all sirial listString arrays
      const combinedSirialList = group.reduce((acc, item) => {
        const sirialData = item.customFields?.sirial
        if (sirialData?.fieldType === ECustomFieldType.LIST_STRING && Array.isArray(sirialData.listString)) {
          return [...acc, ...sirialData.listString]
        }
        return acc
      }, [] as IListStringItem[])

      return {
        ...firstItem,
        customFields: {
          ...firstItem.customFields,
          machine: firstItem.customFields?.machine, // Keep machine from first element
          sirial: {
            fieldType: ECustomFieldType.LIST_STRING,
            listString: combinedSirialList,
          },
        },
      }
    })
  }

  showSensorDialog = false
  displaySensor(trackingDataIndex: number) {
    this.trackingDataIndex = trackingDataIndex
    this.showSensorDialog = true
  }

  // bool? activationData.isLedgerRegistered  //New field, this field shows if activation data is successfully registered to ledger or not. if null, this barcode does not use ledger service or not yet registered. if false, something wrong with ledger service
  // bool? trackingData[index].isLedgerRegistered //New field, this field shows if this data is successfully registered to ledger or not. if null, this barcode does not use ledger service or not yet registered. if false, something wrong with ledger service
  // bool? trackingData[index].isLedgerCertified //Existing field, this field shows if activation data has not been changed at time of this tracking data created. This will be updated every time when reconcile API is called
  // datetime? trackingData[index].lastLedgerCertifiedDateTime //Existing field, this field shows when was the last time this barcode reconciled with ledger

  get isLedgerCertifiedAvailable() {
    return !!this.barcode.isLedgerEnabled
  }

  isDisableLedger(idx: number) {
    return (
      (this.isLedgerCertifiedAvailable && !this.barcode.activationData?.isLedgerRegistered) ||
      (this.isLedgerCertifiedAvailable &&
        this.barcode.activationData?.isLedgerRegistered &&
        !this.trackingDataItemsLoading?.[idx]?.isLedgerRegistered)
    )
  }

  get firstLinkingBarcodes(): IBarcode[] {
    return this.barcode.activationData?.linkedBarcodes || {}
  }

  get hasTrackingData() {
    return !isEmpty(this.distinctTrackingDataKeys?.length)
  }

  get currentBarcodeType() {
    return this.project.barcodeTypes?.[this.barcode.barcodeType]
  }

  get allowTrackingUndo(): boolean {
    return this.currentBarcodeType?.allowTrackingUndo ? this.currentBarcodeType?.allowTrackingUndo : false
  }

  currentTrackPointForm(trackingData: ITrackingData): ITrackPointForms | undefined {
    return this.project.trackPoints?.[trackingData?.currentTrackPointKey]?.trackPointForms?.[
      trackingData?.nextTrackPointKey
    ]
  }

  get linkedBarcodePathKey() {
    return LINKED_BARCODE_PATH_KEY
  }

  get isMaskedData() {
    return this.distinctTrackingDataKeys?.filter((val: ITrackingData) => !isEmpty(val?.maskedFields)).length > 0
  }

  beforeCloseDialog(done: Function) {
    if (!this.isLoading) {
      done()
    }
  }

  closeReconcileDialog() {
    if (!this.isLoading) {
      this.barcodeDialogVisible = false
    }
  }

  isMaskedESign(trackingData: ITrackingData) {
    const eSignObj = this.getValueFromFieldType(
      this.currentTrackPointForm(trackingData)?.customFields as Record<string, ICustomFieldData>,
      FIELD_TYPE.ESIGN
    )
    const isMaskedEsignField = Object.keys(eSignObj).some((key) =>
      trackingData?.maskedFields?.includes(`customFields.${key}`)
    )
    return isMaskedEsignField || false
  }

  isMaskedFiles(trackingData: ITrackingData) {
    const fileObj = this.getValueFromFieldType(
      this.currentTrackPointForm(trackingData)?.customFields as Record<string, ICustomFieldData>,
      FIELD_TYPE.FILES
    )
    const isMaskedFileField = Object.keys(fileObj).some((key) =>
      trackingData?.maskedFields?.includes(`customFields.${key}`)
    )
    return isMaskedFileField || false
  }

  isMaskedLocation(trackingData: ITrackingData) {
    return trackingData?.maskedFields?.includes('location') || false
  }

  isMaskedImage(trackingData: ITrackingData) {
    const fileObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      this.currentTrackPointForm(trackingData)?.customFields as Record<string, ICustomFieldData>,
      FIELD_TYPE.FILES
    )
    const isMaskedImages = Object.keys(fileObj).some(
      (key) => trackingData?.maskedFields?.includes(`customFields.${key}`) && fileObj?.[key]?.fileKind === 'image'
    )
    return isMaskedImages || false
  }

  onLedgerIconClick(idx: number) {
    this.selectedIndex = idx
    if (this.isDisableLedger(idx)) {
      this.trackingDataItemsLoading[idx].isLoading = true
      this.invokeGetLedgerStatus()
    } else this.barcodeDialogVisible = true
  }

  convertedDate(lastLedgerCertifiedDateTime: string) {
    return lastLedgerCertifiedDateTime
      ? format(new Date(lastLedgerCertifiedDateTime || Date()), DATE_TIME.WITH_SECOND).replaceAll('-', '/')
      : ''
  }

  @Emit('barcode:invokeConcile')
  invokeConcile() {
    const index = this.selectedIndex
    this.isLoading = true
    return index
  }

  @Emit('barcode:getLedgerStatus')
  invokeGetLedgerStatus() {
    return this.selectedIndex
  }

  isLastTrackingData(idx: number): boolean {
    return this.distinctTrackingDataKeys.length - 1 === idx
  }

  checkCanDeleteTrackData(idx: number): boolean {
    return idx === this.distinctTrackingDataKeys.length - 1 && !!this.isAction && this.allowTrackingUndo
  }

  getBarcodeTypeInfoByType(barcode: IBarcode): IBarcodeDefinitionType | undefined {
    return barcode.barcodeType ? this.project?.barcodeTypes?.[barcode.barcodeType] : undefined
  }

  isLastestLinkingBarcode(startNode: number) {
    let available = false
    for (let i = startNode; i < this.distinctTrackingDataKeys?.length; i++) {
      if (!isEmpty(this.distinctTrackingDataKeys[i]?.linkedBarcodes)) {
        available = true
        break
      }
    }

    return !available
  }

  stepName(key: string) {
    return this.project.trackPoints?.[key]?.name
  }

  // Optimized helper methods for tracking data rendering
  isSkippedTrackingData(trackingData: ITrackingData): boolean {
    return !!(trackingData.isSkip || trackingData.isSkipCustomValidator)
  }

  getTrackingSpanClass(trackingData: ITrackingData): string {
    if (trackingData.isSkip) return 'bg-red-600'
    if (trackingData.isSkipCustomValidator) return 'bg-yellow-600'
    return 'bg-white'
  }

  getTrackingSpanContent(trackingData: ITrackingData): string {
    return this.isSkippedTrackingData(trackingData) ? '' : trackingData.nextTrackPointKey
  }

  getTrackingTextClass(trackingData: ITrackingData): string {
    if (trackingData.isSkip) return 'text-red-600'
    if (trackingData.isSkipCustomValidator) return 'text-yellow-600'
    return ''
  }

  getTrackingDisplayText(trackingData: ITrackingData): string {
    const stepNameText = this.stepName(trackingData.nextTrackPointKey) || ''

    if (trackingData.isSkip) {
      return `${stepNameText} (${this.$t('skip')})`
    }
    if (trackingData.isSkipCustomValidator) {
      return `${stepNameText} (${this.$t('skip_custom_validator')})`
    }
    return stepNameText
  }

  getTrackingBorderClass(trackingData: ITrackingData, idx: number): string {
    if (this.isLastTrackingData(idx)) return ' '
    if (trackingData.isSkip) return 'border-l-2 border-red-400 border-dashed'
    if (trackingData.isSkipCustomValidator) return 'border-l-2 border-yellow-400 border-dashed'
    return 'border-left'
  }

  getTrackingArrowClass(trackingData: ITrackingData): string {
    if (trackingData.isSkip) return 'text-red-400'
    if (trackingData.isSkipCustomValidator) return 'text-yellow-400'
    return 'text-gray-500'
  }

  extractFieldLabels(current: string, next: string) {
    const tpForms: ITrackPointForms | undefined = this.project.trackPoints?.[current]?.trackPointForms?.[next]
    const fields = tpForms
      ? Object.keys(tpForms).reduce((acc, cur: string) => {
          const newCur = cur as keyof ITrackPointForms
          if (newCur.match(/^custom[a-zA-Z]*Fields/g)) {
            const temp = {} as Record<string, Pick<IFieldSettings, 'label' | 'order'>>
            let maxOrder = 0
            Object.entries(tpForms[newCur] as Record<string, IFieldSettings>).forEach(([fieldKey, fieldSetting]) => {
              temp[fieldKey] = {
                label: fieldSetting.label,
                order: fieldSetting.order,
                ...fieldSetting,
              }
              if (fieldSetting.order && fieldSetting.order > maxOrder) {
                maxOrder = fieldSetting.order
              }
            })

            const customFields = this.project.barcodeTypes?.[this.barcode.barcodeType]?.activationFields?.customFields
            if (customFields) {
              for (const cfKey in customFields) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { order, label, ...field } = customFields[cfKey]
                if (field.fieldType === FIELD_TYPE.ADJUSTMENT && field?.trackPointRoutes) {
                  for (const route of field.trackPointRoutes) {
                    if (route.from === current && route.to === next) {
                      maxOrder++
                      temp[cfKey] = {
                        label: route.customLabel ?? label,
                        order: maxOrder,
                        ...field,
                      }
                    }
                  }
                }
              }
            }
            return { ...acc, ...temp }
          } else return acc
        }, {})
      : {}
    return fields
  }

  extractData(trackingData: ITrackingData) {
    const data: {
      label: string
      value: ICustomFieldData | string | IListStringItem[]
      order?: number
      emissionMap?: { [key: string]: number } | undefined
      measurementHistory?: IWeightMeasurementHistoryItem[] | undefined
      hasFailedFetchingMeasurement?: boolean
      fieldType?: string
    }[] = []

    // if (trackingData?.audit?.trackedDateTime) {
    //   data.push({
    //     label: this.messages.trackedDatetime,
    //     value: {
    //       fieldType: ECustomFieldType.TEXT,
    //       text: format(new Date(trackingData.audit.trackedDateTime as string), DATE_TIME.WITH_SECOND),
    //     },
    //   })
    // }

    if (trackingData?.audit?.trackedUserName) {
      data.push({
        label: this.messages.trackedUsername,
        value: {
          fieldType: ECustomFieldType.TEXT,
          text: trackingData.audit.trackedUserName as string,
        },
      })
    }

    const flattenData = Object.keys(trackingData as ITrackingData).reduce((acc, cur) => {
      if (cur.match(/^custom[a-zA-Z]*/g)) {
        const newTrackingData = JSON.parse(JSON.stringify(trackingData.customFields))
        for (const key in newTrackingData) {
          const newValue = {
            value: newTrackingData[key],
            type: BARCODE_ACTIVATION_DATA_KEYS[cur],
          }
          newTrackingData[key] = newValue
        }
        return { ...acc, ...newTrackingData }
      } else {
        return acc
      }
    }, {}) as Record<string, Record<string, ICustomFieldData>>

    const flattenFields = this.extractFieldLabels(trackingData.currentTrackPointKey, trackingData.nextTrackPointKey)

    const sortedFields = Object.entries(flattenFields as Record<string, TTransformedStructure>).sort((a, b) => {
      const orderA = a[1].order || 999
      const orderB = b[1].order || 999
      return orderA - orderB
    })

    sortedFields.forEach(([fieldKey, fieldValue]) => {
      if (flattenData[fieldKey]) {
        const itemFlattenData = flattenData[fieldKey] as Record<string, ICustomFieldData>
        const value = itemFlattenData.value

        if (!isEmpty(value)) {
          data.push({
            value,
            label: fieldValue.label || fieldKey,
            order: fieldValue.order,
          })
        }
      }
    })

    for (const key in flattenData) {
      const dataFlattenFields = flattenFields as Record<string, unknown>
      if (!dataFlattenFields[key]) {
        data.push({ value: flattenData[key].value, label: key })
      }
    }

    return this.extractValueFromArray(data)
  }

  extractValueFromArray(
    data: {
      label: string
      value: ICustomFieldData | string | IListStringItem[]
      order?: number
      emissionMap?: { [key: string]: number } | undefined
      measurementHistory?: IWeightMeasurementHistoryItem[] | undefined
      hasFailedFetchingMeasurement?: boolean
      fieldType?: string
    }[]
  ) {
    const mappedData = data
      .map((val) => {
        const value = val.value as ICustomFieldData
        if (typeof val.value === 'object' && val.value !== null && 'fieldType' in val.value) {
          if (value?.fieldType === FIELD_TYPE.TEXT) {
            return { value: value.text, label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.EMAIL) {
            return { value: value.email, label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.PHONE_NUMBER) {
            const phoneNo = value.phoneNumber
            if (!phoneNo) return
            if (phoneNo.number === MASKED_STR) return { value: MASKED_STR, label: val.label }

            const dialCode = OTHER_COUNTRY_LIST?.[phoneNo.countryCode as keyof typeof OTHER_COUNTRY_LIST]?.dialCode
            return { value: `${dialCode} ${phoneNo.number}`, label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.NUMBER) {
            return { value: value.number?.toLocaleString(), label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.ADJUSTMENT) {
            return { value: value.adjustment?.toLocaleString(), label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.DATE) {
            return { value: value.date, label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.DATE_TIME) {
            return { value: format(new Date(value.dateTimeData || ''), DATE_TIME.WITH_SECOND), label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.LIST_STRING) {
            if (Array.isArray(value.listString)) {
              return {
                value: value.listString,
                label: val.label,
                fieldType: FIELD_TYPE.LIST_STRING,
              }
            }
            return { value: value.listString, label: val.label, fieldType: FIELD_TYPE.LIST_STRING }
          }
          if (value?.fieldType === FIELD_TYPE.SINGLE_SELECT) {
            if (value.singleSelect) {
              return { value: value?.singleSelect.value, label: val.label }
            }
          }
          if (value?.fieldType === FIELD_TYPE.MULTI_SELECT) {
            if (value.multiSelect) {
              const multiSelect = value.multiSelect || []
              const selectValue = multiSelect
                .reduce((acc, curr) => {
                  return [...acc, curr.value]
                }, [] as string[])
                .join(',')
              return { value: selectValue, label: val.label }
            }
          }
          if (value?.fieldType === FIELD_TYPE.REFERENCE) {
            if (value.reference) {
              if (!value?.reference?.text) {
                return
              }
              return { value: value?.reference.text, label: val.label }
            }
          }
          if (value?.fieldType === FIELD_TYPE.GHG_EMISSION) {
            const ghgEmissionValue = value.ghgEmission
            const ghgEmission = (value as unknown) as GhgEmissionCustomFieldConclusion
            if (ghgEmission.material) {
              const emissionMap = getGhgEmissionMap(ghgEmission.material)
              return { value: ghgEmissionValue, label: val.label, emissionMap: emissionMap }
            }
            return { value: ghgEmissionValue, label: val.label }
          }
          if (value?.fieldType === FIELD_TYPE.CALCULATION) {
            if (value?.calculation) {
              return { value: value?.calculation, label: val.label }
            }
          }
          if (value?.fieldType === FIELD_TYPE.WEIGHT_MEASUREMENT) {
            const weightMeasurement = (value as unknown) as IWeightMeasurement
            const history = weightMeasurement.measurementHistory
              .sort((a, b) => new Date(b.measuredAt).getTime() - new Date(a.measuredAt).getTime())
              .reverse() // oldest top
            return {
              value: weightMeasurement.lastWeight,
              label: val.label,
              measurementHistory: history,
              hasFailedFetchingMeasurement: weightMeasurement.hasFailedFetchingMeasurement,
            }
          }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (
          val.label &&
          val.value &&
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (!('fieldType' in (val.value as any)) || !(val.value as ICustomFieldData)?.fieldType)
        ) {
          return val
        }
      })
      .filter((val) => !!val)

    return mappedData
  }

  @Emit('barcode:undoTracking')
  undoTracking() {
    this.undoConfirmBox = false
    return this.barcode.id
  }

  displayLocation(trackingData: ITrackingData) {
    if (this.isMaskedLocation(trackingData)) return
    const { location } = trackingData
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${location?.latitude},${location?.longitude}`,
      '_blank'
    )
  }

  getValueFromFieldType(data: Record<string, ICustomFieldData>, fieldType: string) {
    try {
      if (!data) return {}
      const filteredData = Object.keys(data).reduce((acc, currKey) => {
        if (data?.[currKey]?.fieldType === fieldType) {
          return { ...acc, [currKey]: data?.[currKey] }
        }
        return acc
      }, {})
      return filteredData || {}
    } catch (e) {
      return {}
    }
  }

  hasEsign(trackingData: ITrackingData) {
    return !isEmpty(this.getValueFromFieldType(trackingData?.customFields, FIELD_TYPE.ESIGN))
  }

  hasFiles(trackingData: ITrackingData) {
    const fileObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.FILES
    )
    const currentTrackPointCustomField = this.currentTrackPointForm(trackingData)?.customFields
    const isHasFiles =
      Object.keys(fileObj)
        .reduce((acc, currKey) => {
          if (
            currentTrackPointCustomField &&
            !['image', 'barcodeScanFrame', 'photoOnly'].includes(
              currentTrackPointCustomField?.[currKey]?.fileKind as string
            )
          ) {
            acc.push(fileObj[currKey])
          }
          return acc
        }, [] as IFieldSettings[])
        .filter((val) => val.files && val?.files?.length > 0).length > 0 || false

    const referenceFileObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.REFERENCE
    )
    const isHasReferenceFiles =
      Object.keys(referenceFileObj)
        .reduce((acc, currKey) => {
          if (currentTrackPointCustomField) {
            acc.push(referenceFileObj[currKey].reference as IReferenceCustomFieldData)
          }
          return acc
        }, [] as IReferenceCustomFieldData[])
        .filter((val) => {
          if (val?.file?.path) {
            return !isImagesFile(val?.file?.path)
          }
        }).length > 0 || false
    return isHasFiles || isHasReferenceFiles
  }

  hasImages(trackingData: ITrackingData) {
    const imagesObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.FILES
    )
    const currentTrackPointCustomField = this.currentTrackPointForm(trackingData)?.customFields
    const isHasImages =
      Object.keys(imagesObj)
        .reduce((acc, currKey) => {
          if (
            currentTrackPointCustomField &&
            ['image', 'barcodeScanFrame', 'photoOnly'].includes(
              currentTrackPointCustomField?.[currKey]?.fileKind as string
            )
          ) {
            acc.push(imagesObj[currKey])
          }
          return acc
        }, [] as IFieldSettings[])
        .filter((val) => val.files && val.files.length > 0).length > 0 || false

    const referenceFileObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.REFERENCE
    )
    const isHasReferenceImages =
      Object.keys(referenceFileObj)
        .reduce((acc, currKey) => {
          if (currentTrackPointCustomField) {
            acc.push(referenceFileObj[currKey].reference as IReferenceCustomFieldData)
          }
          return acc
        }, [] as IReferenceCustomFieldData[])
        .filter((val) => {
          if (val?.file?.path) {
            return isImagesFile(val.file.path)
          }
        }).length > 0 || false

    return isHasImages || isHasReferenceImages
  }

  displaySign(trackingData: ITrackingData) {
    if (this.isMaskedESign(trackingData)) return
    const eSignObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.ESIGN
    )
    const currentTrackPointCustomField = this.currentTrackPointForm(trackingData)?.customFields || {}
    const eSignImageArr = Object.keys(eSignObj).reduce((acc, currKey) => {
      if (!eSignObj?.[currKey]?.eSign) {
        return acc
      }
      const eSign = {
        label: currentTrackPointCustomField?.[currKey]?.label || '',
        eSign: eSignObj?.[currKey]?.eSign || '',
      }
      acc.push(eSign)
      return acc
    }, [] as IEsignData[])
    this.signDialog = true
    this.arrSignImage = eSignImageArr
  }

  onImageCarouselChange(idx: number) {
    this.imageCarouselIndex = idx
  }

  onESignCarouselChange(idx: number) {
    this.eSignCarouselIndex = idx
  }

  get eSignCarouselHeaderLabel() {
    return this.arrSignImage[this.eSignCarouselIndex]?.label || ''
  }

  displayFiles(trackingData: ITrackingData) {
    if (this.isMaskedESign(trackingData)) return
    const fileObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.FILES
    )
    const currentTrackPointCustomField = this.currentTrackPointForm(trackingData)?.customFields
    const fileArr = Object.keys(fileObj).reduce((acc, currKey) => {
      if (
        currentTrackPointCustomField &&
        !['image', 'barcodeScanFrame', 'photoOnly'].includes(
          currentTrackPointCustomField?.[currKey]?.fileKind as string
        )
      ) {
        return [...acc, ...(fileObj?.[currKey]?.files || [])]
      }
      return acc
    }, [] as IFile[])

    const referemceFileObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.REFERENCE
    )
    const referenceFileArr = Object.keys(referemceFileObj)
      .reduce((acc, currKey) => {
        if (currentTrackPointCustomField && referemceFileObj?.[currKey]?.reference) {
          const referenceData = referemceFileObj?.[currKey].reference as IReferenceCustomFieldData
          return [...[referenceData.file], ...acc]
        }
        return acc
      }, [] as IFile[])
      .filter((val) => {
        if (val?.path) {
          return !isImagesFile(val.path)
        }
      })
    this.fileDialog = true
    this.arrFile = [...fileArr, ...referenceFileArr]
  }

  displayImages(trackingData: ITrackingData) {
    if (this.isMaskedESign(trackingData)) return
    const imageObjSetting: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.FILES
    )
    const currentTrackPointCustomField = this.currentTrackPointForm(trackingData)?.customFields
    const imageObj = Object.keys(imageObjSetting).reduce((acc, currKey) => {
      if (
        imageObjSetting[currKey] &&
        ['image', 'barcodeScanFrame', 'photoOnly'].includes(currentTrackPointCustomField?.[currKey]?.fileKind as string)
      ) {
        const getLabelFromKey = currentTrackPointCustomField?.[currKey]?.label
        const files: IFile[] = imageObjSetting?.[currKey]?.files || []
        return { ...acc, [getLabelFromKey || '']: files }
      }

      return acc
    }, {})

    const referemceFileObj: Record<string, IFieldSettings> = this.getValueFromFieldType(
      trackingData?.customFields,
      FIELD_TYPE.REFERENCE
    )
    const referenceImageObj = Object.keys(referemceFileObj).reduce((acc, currKey) => {
      if (referemceFileObj[currKey]) {
        const referenceData = referemceFileObj?.[currKey].reference as IReferenceCustomFieldData
        const getLabelFromKey = currentTrackPointCustomField?.[currKey]?.label
        if (referenceData?.file?.path) {
          const isImageFile = isImagesFile(referenceData?.file?.path)
          if (isImageFile) {
            return { ...acc, [getLabelFromKey || '']: [referenceData.file] }
          }
          return { ...acc }
        }
      }

      return acc
    }, [] as IFile[])
    this.images = { ...imageObj, ...referenceImageObj }
    this.imageDialogVisible = true
  }

  onPreview(url: string) {
    window.open(url, '_blank')
  }

  hasGhgEmissionMap(
    data:
      | Record<string, IFieldSettings>
      | {
          value: string | undefined
          label: IFieldSettings
          emissionMap: { [key: string]: number } | undefined
          measurementHistory: IWeightMeasurementHistoryItem[] | undefined
        }
      | undefined
  ) {
    return !!data?.emissionMap
  }

  hasWeightMeasurement(
    data:
      | Record<string, IFieldSettings>
      | {
          fieldType: string | undefined
          value: string | undefined
          label: IFieldSettings
          emissionMap: { [key: string]: number } | undefined
          measurementHistory: IWeightMeasurementHistoryItem[] | undefined
        }
      | undefined
  ) {
    return data?.measurementHistory !== undefined
  }

  getWeightMeasurementDateText(measurement: IWeightMeasurementHistoryItem) {
    const measuredAt = new Date(measurement.measuredAt)
    const measuredAtText = format(measuredAt, 'yyyy/MM/dd HH:mm:ss')
    return measuredAtText
  }

  getWeightMeasurementWeightText(measurement: IWeightMeasurementHistoryItem) {
    return `${measurement.current}${this.$t('weight_measurement.unit')}`
  }

  getWeightMeasurementPushedMesureButtonText(measurement: IWeightMeasurementHistoryItem) {
    return measurement.pushedMeasureButton ? this.$t('weight_measurement.manual') : this.$t('weight_measurement.auto')
  }

  hasFailedToFetchWeightMeasurement(measurement: IWeightMeasurement) {
    return !!measurement.hasFailedFetchingMeasurement
  }

  hasNoWeightMeasurement(measurement: IWeightMeasurement) {
    return measurement.measurementHistory.length === 0
  }

  isListStringField(fieldType?: string) {
    return fieldType === FIELD_TYPE.LIST_STRING
  }

  showListStringModal(data: IListStringItem[], fieldLabel: string) {
    if (Array.isArray(data)) {
      this.listStringData = data.map((item) => {
        if (typeof item === 'string') {
          return {
            code: item,
            limitAmount: undefined,
            currentAmount: undefined,
            unit: undefined,
            createdDateTime: undefined,
            scannedDateTime: undefined,
            orderNumber: undefined,
            machineCode: undefined,
          }
        }
        return item
      })
    } else {
      this.listStringData = []
    }
    this.currentFieldLabel = fieldLabel
    this.listStringModalVisible = true
  }

  formatDateTime(dateTime: string) {
    if (!dateTime) return ''
    try {
      return format(new Date(dateTime), DATE_TIME.WITH_SECOND)
    } catch (error) {
      return dateTime
    }
  }

  @Emit('barcode:unlink')
  unlinkBarcode(barcodeId: string) {
    return barcodeId
  }

  @Emit('web:redirect')
  redirectTo(data: IRedirectData): IRedirectData {
    return data
  }

  handleEditTrackingData(key: string, index: number) {
    this.$router.push({
      name: 'track',
      params: {
        project: this.projectParam,
        barcodeId: this.barcode?.id,
        keyEdit: key,
        index: index,
        prevTrackPointKey: this.distinctTrackingDataKeys[index].currentTrackPointKey,
      },
    })
  }

  get projectParam() {
    return this.$store.getters.projectParam
  }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@400;700&display=swap');

.table-scroll-container-tracing {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: auto;
  border-radius: 12px;
  border: 0.5px solid #e0e0e0;
}

.rounded-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: none;
}

.sticky-header-table-tracing {
  display: table;
  width: 100%;
}

table thead th {
  background-color: #e0e0e0;
  color: #333333;
  font-weight: bold;
  padding: 20px 0;
  border: 0.5px solid #ebeef5;
  border-bottom: 0.5px solid #ddd;
  position: sticky;
  top: 0;
  z-index: 10;
}

td {
  border: 0.5px solid #ddd;
  padding: 8px;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  vertical-align: middle;
  max-width: 80px;
}
.icon {
  width: 32px;
  height: 32px;
}

.masked-lock-icon {
  position: absolute;
  right: 0;
  bottom: 0;
}

.last-confirm-small {
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  color: #000000;
}

.ledger-certified {
  font-family: Noto Sans JP;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
}

.barcode-id-small {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  color: #979797;
}

.trackpoint-concile-content {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  /* identical to box height */

  color: #000000;
}

.concile-dialog-content-data {
  font-family: 'Noto Sans', sans-serif;
  width: 100%;
  margin: 20px 10px 0px;

  &__id {
    color: #979797;
  }

  &__key-value-item {
    padding: 4px;
    display: flex;
    color: black;

    div:first-child {
      text-align: right;
      margin-right: 5px;
      flex-basis: 50%;
      min-width: 50%;
    }

    div:last-child {
      text-align: left;
    }
  }
}

.reconcile-btn {
  min-width: 120px;
  background-color: #c4c4c4;
  color: #ffffff;

  &.is-round {
    height: 64px;
    border-radius: 40px !important;
    box-sizing: border-box !important;
  }
}

.ok-btn {
  width: 64px;
  height: 64px;
  background: #525252;
  color: #ffffff;

  &.is-round {
    height: 64px;
    border-radius: 40px !important;
    box-sizing: border-box !important;
  }
}

.serial-dialog-area :deep() {
  .el-overlay .el-dialog {
    width: 80% !important;
    max-width: 100%;
  }
}
.dialog-area :deep() {
  .el-dialog__header {
    padding: 20px;
    text-align: left;
    background-color: #525252;

    .el-dialog__title {
      color: #ffffff;
    }
  }

  .el-dialog__body {
    word-break: normal;
  }

  .el-dialog__headerbtn {
    background-color: #ffffff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
  }

  .barcode-label-container {
    display: flex;
    padding: 5px;
    margin: 0px;

    .action-menu {
      width: auto;
    }
  }
}

.tracking-record {
  &-title {
    .el-button--text {
      color: white;
    }
  }

  .el-button--mini {
    padding: 0px;
  }

  .el-button--mini svg {
    max-width: 22px;
  }

  .arrow-line {
    left: -1px;
    top: calc(100% - 4px);
    transform: translate(-50%, -50%);
  }
}

.border-left {
  border-left: 2px solid #959595;
}

.step-body {
  .label-box-custom {
    font-size: 14px;
    min-width: 50px;
    padding: 2px 8px;
    margin-right: 6px;
    border: 1px solid #c4c4c4;
    border-radius: 4px;
    line-height: 20px;
    display: inline-block;
    font-weight: 500;
  }
}

.tracking-record:last-child {
  .step-body {
    border-left: 0;
  }
}

.image-dialog {
  &.el-dialog {
    .el-dialog__body {
      padding-top: 0;
    }
  }
}

.w-full--20 {
  width: calc(100% - 5rem);
}

.text-gray-400 {
  color: rgb(156, 163, 175);
}

.h-6 {
  height: 1.5rem;
}

.leading-6 {
  line-height: 1.5rem;
}

.bg-blue-400 {
  background-color: rgb(96, 165, 250);
}

.tracing-dialog::v-deep() {
  &.el-dialog {
    background-color: #f2f2f2;
    border-radius: 10px;
    max-height: 90%;
    overflow: hidden;
    flex-direction: column;
    display: flex;
    margin: 0;

    &__header {
      font-weight: bold;
      border-bottom: 1px solid #bdbdbd;
      padding: 25px;
    }

    .el-carousel {
      &__item {
        justify-content: center;
        display: none;

        &.is-active {
          display: flex;
        }
      }
    }

    .el-image {
      overflow: auto;
    }
  }
}

.file-and-value {
  display: flex;
  padding: 8px 0px;

  > div {
    flex-basis: 35%;
    text-align: right;
    margin-right: 8px;
    min-width: 35%;
  }
}

::v-deep .list-string-modal {
  .el-dialog__header {
    padding-bottom: 0px;
  }

  max-width: 1000px !important;
}

.table-container {
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 0;
}

.items-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;

  .table-row {
    border-bottom: 1px solid #f0f0f0;

    &:hover {
      background-color: #f9f9f9;
    }
  }

  td {
    padding: 8px 6px;
    vertical-align: middle;
    border-right: 1px solid #f0f0f0;

    &:last-child {
      border-right: none;
    }
  }

  .index-cell {
    width: 30px;
    text-align: center;
    font-weight: 600;
    color: #666;
    font-size: 11px;
  }

  .code-cell {
    width: 90px;
    font-weight: 500;
    color: #333;
    text-align: left;
  }

  .amount-unit-cell {
    width: 60px;
    text-align: center;
    .amount-unit-display {
      font-weight: 600;
    }
  }

  .table-header {
    background-color: #f5f7fa;
    border-bottom: 2px solid #e0e0e0;

    th {
      padding: 10px 6px;
      text-align: center;
      font-weight: 600;
      color: #555;
      font-size: 11px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      border-right: 1px solid #e9ecef;

      &:last-child {
        border-right: none;
      }

      &.code-cell {
        text-align: left;
      }
    }
  }
}

.trolley-cell {
  text-align: center;

  .trolly-info {
    justify-content: center;
    display: flex;
    align-items: center;
    gap: 4px;
  }

  .trolley-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px 6px;
    border-radius: 6px;
    font-weight: 600;
    white-space: nowrap;
    font-size: 10px;
  }

  .trolley-number-badge {
    background-color: #f3f4f6;
    color: #333;
    border: 1px solid #333;

    .trolley-icon-small {
      width: 10px;
      height: 10px;
      flex-shrink: 0;
    }
  }

  .trolley-index-badge {
    background-color: #e9ecef;
    color: #666;
    border: 1px solid #adb5bd;
  }

  .empty-value {
    color: #ccc;
    font-style: italic;
  }
}
</style>
